import React from 'react';
import G from './Getters';
import C from './Constants';

import computeFilters from './computeFilters';

import imageMap from './imageMap';

const toRad = degree => {
  return Math.PI * 2 * degree / 360;
}

const breaks = [{start:0.2,end:0.4},{start:0.7,end:0.8}]

export default function CropPreview({  
  parentWidth, 
  temporaryAdjustments,
  mediaId,
  imageId,
  htmlImageId, 
  htmlImageClipDivId,
  filterId,
  imgRef,
  crop,
  imageRecord,
  src
}){

  const [computedWidth,setTargetWidth] = React.useState(null);
  const containerRef = React.useRef(null);

  let targetWidth = (parentWidth || computedWidth) 
  
  let transform = `rotate(${-crop?.rotation||0}deg)`

  let cropWidth = crop.width;

  let imgStyle = {
    position:'absolute',
    top: -crop.top * targetWidth / cropWidth,
    left: -crop.left * targetWidth / cropWidth,
    width: targetWidth / cropWidth,
    //border:'1px solid red',
    transform, 
    ...computeFilters(temporaryAdjustments||imageRecord.adjustments)
  }

  if( filterId ){
    imgStyle.filter = `url(#${filterId})`;
  }else{
  }

  



  let resolvedSource = imageMap[src]||imageMap[imageId]||src;

  let img = (<img 
    mediaId={mediaId}
                imageId={imageId}
                type="image-resource"
                ref={imgRef}
                id={htmlImageId}
              class={"no-drag"} 
              src={resolvedSource} 
              style={imgStyle} />)

  
  return (
    <div
      class={"crop-preview-outer-div"}

      

      ref={containerRef} 

      style={{
        position:'relative',
        width:'100%',
      }}>


      {targetWidth && 
      <>
        <div id={htmlImageClipDivId}
          //class="image-parent"
          
          style={{
            position: "relative",
            overflow: "hidden",
            width: targetWidth,
            height: targetWidth / crop.width * crop.height,
          }}
        >
          {targetWidth !== null && (
            <>{img} </>
          )}

        </div>
      </>
      }
    </div>
  );
}
